import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { MyContactsDTO } from '../Models/Contact.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import { Login } from "../Services/login-service";
@Component({
  selector: 'app-impersonation',
  templateUrl: './impersonation.component.html',
  styleUrls: ['./impersonation.component.scss'],
  providers: [SrubUpService]
})

export class ImpersonationComponent implements OnInit {
  supertoken:any;
  loginUserId: number;
  toImpersonateUserId: number;

  public loading = false;
  searchUser: string;
  searchUsertxt: string;

  searchvisi: number;
  invite: number;
  inviteemail: string;
  storeindex: number;

  searchUserDetails: Array<MyContactsDTO>;
  isImpersonateMode: boolean;

  constructor(public loginservice:Login,private router: Router, private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    Globals.ImpersonationValue = false;
    this.isImpersonateMode = Globals.ImpersonationValue;
    this.loginUserId = this.appUserDetails.UserId;
    this.searchvisi = 0;
    this.invite = 0;
    this.storeindex = -1;
    this.searchUserDetails = new Array<MyContactsDTO>();
  }

  ImpersonateUser(index: number,username:any,id:any) {

    console.log('this.cookieService.get("superToken")================', this.cookieService.get("sup-access-token"));
    console.log('this.token================', this.token);
    //this.loading = true;

    // let Formdata=new FormData();
    // Formdata.append("userName",username);
    this.scrubUpService.impersonateLogin(username, this.cookieService.get("sup-access-token")).subscribe(x => {
      //console.log(x);

      if (x.userName != null && x.access_token != null) {
        this.loading = false;
        this.searchUserDetails = x;
        this.searchvisi = 1;
        this.invite = 0;
        this.searchUsertxt = this.searchUser;
        this.cookieService.delete('Token');
        this.token.access_token = x.access_token;
        this.cookieService.set('accessToken', this.token.access_token);
        this.token.userName = x.userName;
        this.token.expires = x.expires;
        this.token.expires_in = x.expires_in;
        this.token.issued = x.issued;
        this.token.token_type = x.token_type;

        this.toImpersonateUserId = id;

        this.appUserDetails.UserId = this.toImpersonateUserId;
        this.cookieService.set('userId', this.appUserDetails.UserId.toString());

        this.cookieService.set('Token',JSON.stringify(this.token));
        this.cookieService.set('super-access-token', this.token.access_token);
        this.cookieService.set('access-token', this.token.access_token);

        Globals.ImpersonationValue = true;
        this.cookieService.set('impersonation', "true");
        this.router.navigateByUrl('sidebar', { skipLocationChange: true }).then(() =>
        this.router.navigate(["layout/user-speciality"]));

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })



  }

  GetSearchUsersContactInfo() {
    this.searchUserDetails = [];
    this.loading = true;
    const search = this.searchUser ? this.searchUser : "";

    this.scrubUpService.GetSearchUsersContactInfo(this.cookieService.get("sup-access-token"), this.loginUserId, search).subscribe(x => {
      if (x != null && x != undefined) {
        this.loading = false;
        this.searchUserDetails = x;
        this.searchvisi = 1;
        this.invite = 0;
        this.searchUsertxt = this.searchUser;
      }
    // console.log(this.searchUserDetails);
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  opensearchcontents() {
    this.searchvisi = 1;
    this.invite = 0;
  }

  closesearchcontents() {
    this.searchvisi = 0;
  }

  Addcontacts() {
    this.searchvisi = 0;
  }

  ngOnInit() {
    this.GetSearchUsersContactInfo();
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/impersonation/impersonation.component.ts